module.exports = __webpack_public_path__ + "img/20260916_daimuzhi.5c426eaf.jpg";